import { useReveal } from "@/hooks/useReveal";

export const Reveal = ({ children, className = "", as: Tag = "div", delay = 0 }) => {
  const [ref, inView] = useReveal();
  return (
    <Tag ref={ref} className={`reveal ${inView ? "in-view" : ""} ${className}`} style={{ transitionDelay: `${delay}ms` }}>
      {children}
    </Tag>
  );
};
